exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NYg6yxQbsMH-ViZo7zC4S{position:absolute;top:180px;left:25%;width:50%;background-color:#fff;z-index:1;max-width:600px;min-width:200px;max-height:550px;text-align:center}._2fU20IdU7NIvw2u04n7AgM{height:45px;width:100%;text-align:left}._28yR4FltiNCDmAfcQxdgIM{line-height:45px;margin-left:5%}._1BoUwUp9rxdQIEOc14IXaY{color:#4498c0;border:none;background-color:#fff;float:right;margin-right:5%;margin-top:8px;padding:0;width:24px;height:24px}._1BoUwUp9rxdQIEOc14IXaY:focus{outline:none}._2oX3Qu3qna2EuPhwuOpRvA{height:100%;width:100%;padding:0 5%}._1hWcbqTzevnnsoos_UZZIA{height:45px;width:100%;bottom:0}", ""]);

// exports
exports.locals = {
	"container": "NYg6yxQbsMH-ViZo7zC4S",
	"titlebar": "_2fU20IdU7NIvw2u04n7AgM",
	"title": "_28yR4FltiNCDmAfcQxdgIM",
	"exit": "_1BoUwUp9rxdQIEOc14IXaY",
	"body": "_2oX3Qu3qna2EuPhwuOpRvA",
	"footer": "_1hWcbqTzevnnsoos_UZZIA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./app/styles/aoi/PopupBox.css
// module id = 1457
// module chunks = 1